import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import '../../assets/css/AddNewAccount.css';
import UserPanelSidebar from "../components/UserPanelSidebar";

const AddNewAccount = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [relatedEntityId, setRelatedEntityId] = useState('');
    const [message, setMessage] = useState(null); // State to hold success or error messages

    const handleSaveAccount = async () => {
        setMessage(null); // Clear any previous message

        // Check if all required fields are filled
        if (!email || !password || !relatedEntityId) {
            setMessage("All fields are required. Please fill in all fields and try again.");
            return;
        }

        try {
            const auth = getAuth();
            // Create user in Firebase Auth
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // Store user information in Firestore under the "users" collection
            await setDoc(doc(db, 'users', user.uid), {
                email,
                related_entity_number: parseInt(relatedEntityId, 10)
            });

            setMessage("The new account has been successfully saved.");
            setEmail('');
            setPassword('');
            setRelatedEntityId('');
        } catch (error) {
            console.error("Error creating user:", error);
            setMessage("Error creating user. Please check the information and try again later.");
        }
    };

    return (
        <div className="add-new-account-page">
            <UserPanelSidebar />
            <div className="add-new-account-container">
                <div className="section">
                    <h3 className="section-title">Add New Account</h3>
                    <div className="input-wrapper">
                        <label className="input-label">Email Address *</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input-field"
                            required
                        />
                    </div>
                    <div className="input-wrapper">
                        <label className="input-label">Password *</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input-field"
                            required
                        />
                    </div>
                    <div className="input-wrapper">
                        <label className="input-label">Related Entity ID *</label>
                        <input
                            type="number"
                            value={relatedEntityId}
                            onChange={(e) => setRelatedEntityId(e.target.value)}
                            className="input-field"
                            required
                        />
                    </div>
                    <button className="save-button" onClick={handleSaveAccount}>Save Account</button>

                    {/* Success/Error Message Modal */}
                    {message && (
                        <div className="modal" onClick={() => setMessage(null)}>
                            <div className="modal-content">
                                <p>{message}</p>
                                <button onClick={() => setMessage(null)} className="close-btn">Close</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AddNewAccount;
